export const AdType = {
	DISPLAY_AD:      'display_ad',
	BANNER_AD:       'banner_ad',
	SPONSORS_HEADER: 'sponsors_header',
	PLAYER_LOGO:     'player_logo',
	PLAYER_BANNER:   'player_banner',
	PLAYER_AD:       'player_ad',
	EVENT_BANNER:    'event_banner',
};
